const Stars = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8236 1.3999C15.242 1.3999 15.6162 1.66043 15.7614 2.05287L17.4321 6.56783L21.9471 8.23852C22.3395 8.38374 22.6 8.75793 22.6 9.17637C22.6 9.59481 22.3395 9.96901 21.9471 10.1142L17.4321 11.7849L15.7614 16.2999C15.6162 16.6923 15.242 16.9528 14.8236 16.9528C14.4051 16.9528 14.0309 16.6923 13.8857 16.2999L12.215 11.7849L7.70005 10.1142C7.30761 9.96901 7.04708 9.59481 7.04708 9.17637C7.04708 8.75793 7.30761 8.38374 7.70005 8.23852L12.215 6.56783L13.8857 2.05287C14.0309 1.66043 14.4051 1.3999 14.8236 1.3999ZM14.8236 5.28144L13.9311 7.69315C13.8299 7.96687 13.614 8.18268 13.3403 8.28396L10.9286 9.17637L13.3403 10.0688C13.614 10.1701 13.8299 10.3859 13.9311 10.6596L14.8236 13.0713L15.716 10.6596C15.8173 10.3859 16.0331 10.1701 16.3068 10.0688L18.7185 9.17637L16.3068 8.28396C16.0331 8.18268 15.8173 7.96687 15.716 7.69315L14.8236 5.28144ZM6.35297 12.694C6.68427 12.694 6.99407 12.8581 7.18021 13.1322L8.67169 15.3282L10.8677 16.8197C11.1418 17.0059 11.3059 17.3157 11.3059 17.647C11.3059 17.9783 11.1418 18.2881 10.8677 18.4742L8.67169 19.9657L7.18021 22.1617C6.99407 22.4358 6.68427 22.5999 6.35297 22.5999C6.02166 22.5999 5.71186 22.4358 5.52572 22.1617L4.03424 19.9657L1.83819 18.4742C1.56411 18.2881 1.40002 17.9783 1.40002 17.647C1.40002 17.3157 1.56411 17.0059 1.83819 16.8197L4.03424 15.3282L5.52572 13.1322C5.71186 12.8581 6.02166 12.694 6.35297 12.694ZM6.35297 15.4739L5.58139 16.61C5.51046 16.7144 5.42041 16.8045 5.31598 16.8754L4.1799 17.647L5.31598 18.4185C5.42041 18.4895 5.51046 18.5795 5.58139 18.684L6.35297 19.82L7.12454 18.684C7.19547 18.5795 7.28553 18.4895 7.38996 18.4185L8.52603 17.647L7.38996 16.8754C7.28553 16.8045 7.19547 16.7144 7.12454 16.61L6.35297 15.4739Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Stars;
